export const GOVERNANCE_ACTION_SORT_OPTIONS = [
  {
    value: "newestFirst",
    label: "Newest First",
    displayLabel: "Newest first",
    dataTestId: "newest-first",
  },
  {
    value: "oldestFirst",
    label: "Oldest First",
    displayLabel: "Oldest first",
    dataTestId: "oldest-first",
  },
  {
    value: "highestYesVotes",
    label: "Highest amount of yes votes",
    displayLabel: "Yes votes",
    dataTestId: "highest-amount-of-yes-vote",
  },
];
